import { ChatDrawerMessage } from 'ducks/chatDrawer'

const formatTimestamp = (date: Date): string => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')

  return `${year}-${month}-${day}, ${hours}:${minutes}:${seconds}`
}

export const formatChatTranscript = (messages: ChatDrawerMessage[]): string => {
  const currentTime = new Date()

  const transcript = messages
    .map((message) => {
      const sender = message.direction === 'send' ? 'User' : 'Ada'
      const timestamp = formatTimestamp(currentTime)
      return `[${timestamp}] ${sender}: ${message.content}`
    })
    .join('\n\n')

  return transcript
}

export const copyChatTranscriptToClipboard = async (messages: ChatDrawerMessage[]): Promise<boolean> => {
  if (messages.length === 0) {
    return false
  }

  try {
    const transcript = formatChatTranscript(messages)
    await navigator.clipboard.writeText(transcript)
    return true
  } catch (error) {
    console.error('Failed to copy transcript:', error)
    return false
  }
}
